import type {
  ApiResponse,
  RefreshTokenData,
  SignInResponse,
} from '../types/auth';

/**
 * Merges POST /auth/refresh-token data into the stored sign-in session.
 * Cognito does not return a new refresh token on refresh; we always keep the existing one.
 */
export function mergeSessionAfterRefresh(
  session: SignInResponse,
  refresh: ApiResponse<RefreshTokenData>,
): SignInResponse | null {
  if (!refresh.success || !refresh.data?.accessToken || !refresh.data.idToken) {
    return null;
  }
  return {
    ...session,
    message: refresh.message ?? session.message,
    data: {
      ...session.data,
      accessToken: refresh.data.accessToken,
      idToken: refresh.data.idToken,
      expiresIn: refresh.data.expiresIn,
      tokenType: refresh.data.tokenType,
      refreshToken: session.data.refreshToken,
    },
  };
}
